<template>
	<div>
		<el-carousel :height="lbHeight + 'px'">
			<el-carousel-item v-for="(item, index) in imgArr" :key="index">
				<img :src="$imgUrl + item.bannerImg" class="bgimgs" alt="" />
			</el-carousel-item>
		</el-carousel>
	</div>
</template>

<script>
export default {
	name: 'lunBo',
	data() {
		return {};
	},
	props: {
		lbHeight: {
			default: '',
			type: String
		},
		imgArr: {
			default: [],
			type: Array
		}
	},
	methods: {},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.bgimgs {
	width: 100%;
	height: 100%;
	border-radius: 6px;
	object-fit: cover;
}
</style>
